import { BaseTextInput } from 'inputs'
import { BaseModal } from 'layout'
import { BaseTesto } from 'text'
import { generaUUID } from 'utils'
import { ENTITA_BASE } from '../EntitaBase'
import FormModificaEntita from '../entitaGenerica/components/FormModificaEntita'
import ListaScatoleEntita from '../entitaGenerica/components/ListaScatoleEntita'
import HeaderContenutoMultimediale from './components/HeaderContenutoMultimediale'

export default function ModalContenutiMultimediali(props) {
  const {
    documentoInput,
    propsEntita,
    chiudiModifica,
    documentoCongelato,
  } = props

  return (
    <BaseModal
      titolo='Contenuti multimediali associati al documento'
      open={true}
      onClose={chiudiModifica}
      contenutoNonCentrato
      maxWidth='md'
    >
      <ContenutoModalMetadati
        documentoInput={documentoInput}
        pathDocumento={propsEntita.pathEntita}
        documentoCongelato={documentoCongelato}
      />
    </BaseModal>
  )
}



function ContenutoModalMetadati(props) {
  const { documentoInput, pathDocumento, documentoCongelato } = props
  const { fileMultimediali = [] } = documentoInput

  if (documentoCongelato && fileMultimediali.length === 0) {
    return (
      <BaseTesto color='textSecondary' sx={{ textAlign: 'center' }}>
        Nessun contenuto multimediale associato
      </BaseTesto>
    )
  }

  return (
    <ListaScatoleEntita
      propsEntita={{
        nomeEntita: ENTITA_BASE.DOCUMENTO_FILE_MULTIMEDIALE,
        pathEntita: pathDocumento.addPath('fileMultimediali'),
        valoriInput: fileMultimediali
      }}
      renderEntita={contenuto => <HeaderContenutoMultimediale contenuto={contenuto} />}
      renderFormModifica={FormContenutoMultimediale}
      propsBottoneCrea={{
        testo: 'Aggiungi contenuto multimediale',
        opzioniCreazione: {
          entitaGiaCreata: {
            uuid: generaUUID(),
            titolo: '',
            note: ''
          }
        }
      }}
      {...(documentoCongelato && { 
        noCrea: true, 
        noModifica: true, 
        noElimina: true 
      })}
    />
  )
}



const NOMI = {
  TITOLO: 'titolo',
  NOTE: 'note'
}

function FormContenutoMultimediale(props) {
  const { propsEntita } = props

  return (
    <FormModificaEntita {...propsEntita} larghezzaInputs={40}>
      <BaseTextInput
        label='Titolo' name={NOMI.TITOLO}
      />
      <br/>
      <BaseTextInput
        label='Note' name={NOMI.NOTE}
        multiline rows={2}
      />
    </FormModificaEntita>
  )
}